import MoodFlix from "./moodflix";
export default function App(){ return <MoodFlix/> }
